module.exports = __webpack_public_path__ + "img/GT.4766b57d.svg";